import React, { useState } from 'react';
import { Modal, Button, ListGroup } from 'react-bootstrap';
import './DocumentPopup.css';

const DocumentPopup = ({ show, handleClose, documents, handleDelete }) => {
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [showViewer, setShowViewer] = useState(false);

    const handleViewDocument = (document) => {
        setSelectedDocument(document);
        setShowViewer(true);
    };

    const closeViewer = () => {
        setShowViewer(false);
        setSelectedDocument(null);
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} centered className="document-popup-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Documents</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {documents.length === 0 ? (
                        <div className="text-center py-4">
                            <p className="text-muted mb-0">No documents uploaded yet.</p>
                        </div>
                    ) : (
                        <ListGroup>
                            {documents.map(doc => (
                                <ListGroup.Item key={doc.dataId} className="d-flex justify-content-between align-items-center">
                                    <span>{doc.key.replace('webdata/documents/', '')}</span>
                                    <div className="btn-group">
                                        <Button variant="primary" onClick={() => handleViewDocument(doc)}>
                                            View
                                        </Button>
                                        <Button variant="danger" onClick={() => handleDelete(doc.dataId, doc.name)}>
                                            Delete
                                        </Button>
                                    </div>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Document Viewer Modal */}
            <Modal show={showViewer} onHide={closeViewer} centered size="xl" className="document-viewer-modal">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedDocument ? selectedDocument.key.replace('webdata/documents/', '') : 'Document Viewer'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {selectedDocument && (
                        <iframe
                            src={`${selectedDocument.url}#toolbar=1&navpanes=1&scrollbar=1`}
                            width="100%"
                            height="70vh"
                            style={{ border: 'none', borderRadius: '8px' }}
                            title="Document Viewer"
                            className="document-viewer"
                        />
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeViewer}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DocumentPopup; 